export default __webpack_public_path__ + "static/media/about_img5.65134d01.svg";